import React from 'react'
import Time from './timer'
function Head(props) {
      return(
        <div class="hub">
        <header class="d-flex justify-between align-center">
        <a href="/" class="brand-logo">
            <img src="./images/logo.svg" alt="CONTROLHUB"></img>
            <img src="https://www.auctionsoftware.com/wp-content/uploads/2019/04/asLogonew.png" width="50%" alt="CONTROLHUB"></img>
        </a>
        <div class="mobile-nav">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <ul class="p-0 list-none d-flex mobile-view">
            {/* <li>Customer Stories</li> */}
            {/* <li><a href="http://localhost:3000/">Pricing</a></li> */}
            {/* <li><a href="http://controlhub.auctionsoftware.com/customer" target="_blank">Login</a></li> */}
            <li><a class="orange-btn" href="https://www.auctionsoftware.com/contact-us/" target="_blank">Contact Us</a></li>
        </ul>
      </header> 
       </div>);
    }
  export default Head;
     

  